import AuthClientStore from '../services/auth-client.service';

/**
 * Fetch a binary endpoint as a PDF blob using the app's real access token
 * (`ardealy.bo.access.token` via AuthClientStore) — NOT the global axios
 * interceptor, which reads a different localStorage key. Throws on a non-OK
 * response so callers can surface the failure.
 */
async function fetchPdfBlob(path: string): Promise<Blob> {
  const token = AuthClientStore.getAccessToken();
  const res = await fetch(`${process.env.REACT_APP_PMS_API_URL}${path}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) throw new Error(`Failed to load PDF (${res.status})`);
  return new Blob([await res.arrayBuffer()], { type: 'application/pdf' });
}

/** Fetch a PDF and trigger a browser download. */
export async function downloadPdf(path: string, filename: string): Promise<void> {
  const url = window.URL.createObjectURL(await fetchPdfBlob(path));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.pdf') ? filename : `${filename}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

/**
 * Fetch a PDF and return a blob object URL for INLINE viewing (e.g. in an
 * iframe) — no download. Caller must revoke the URL when done.
 */
export async function fetchPdfObjectUrl(path: string): Promise<string> {
  return window.URL.createObjectURL(await fetchPdfBlob(path));
}
